/**
 * BondConditionsSection - Monitors, drug testing, check-in type/frequency
 */

import { OathInput, OathSelect } from '../../../shared/OathUI';
import { CHECK_IN_TYPES } from '../shared/largeBondConstants';

const BondConditionsSection = ({ formState, dispatch, disabled }) => {
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  const toggleCheckbox = (field) => () =>
    dispatch({ type: 'SET_FIELD', field, value: !formState[field] });

  return (
    <div>
      <h4 className="font-medium text-gray-900 dark:text-white mb-3">Bond Conditions</h4>
      <div className="space-y-4">
        {/* Checkboxes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
            <input
              type="checkbox"
              checked={formState.courtOrderedMonitor}
              onChange={toggleCheckbox('courtOrderedMonitor')}
              disabled={disabled}
              className="accent-primary h-4 w-4"
            />
            Ankle Monitor: Court Order
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
            <input
              type="checkbox"
              checked={formState.agentRequiredMonitor}
              onChange={toggleCheckbox('agentRequiredMonitor')}
              disabled={disabled}
              className="accent-primary h-4 w-4"
            />
            Ankle Monitor: Agent Required
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
            <input
              type="checkbox"
              checked={formState.pretrialIntervention}
              onChange={toggleCheckbox('pretrialIntervention')}
              disabled={disabled}
              className="accent-primary h-4 w-4"
            />
            Pretrial Intervention
          </label>
          <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
            <input
              type="checkbox"
              checked={formState.drugTesting}
              onChange={toggleCheckbox('drugTesting')}
              disabled={disabled}
              className="accent-primary h-4 w-4"
            />
            Court Mandated Drug & Alcohol Testing
          </label>
        </div>

        {/* Description */}
        <OathInput
          label="Description of Bond Conditions"
          value={formState.conditionDescription}
          onChange={set('conditionDescription')}
          placeholder="Describe any bond conditions"
          disabled={disabled}
        />

        {/* Check-in fields */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <OathSelect
            label="Agency Check-in Type"
            value={formState.checkInType}
            onChange={set('checkInType')}
            options={CHECK_IN_TYPES.filter((o) => o.value !== '')}
            placeholder="Select..."
            disabled={disabled}
          />
          <OathInput
            label="Check-in Frequency"
            value={formState.checkInFrequency}
            onChange={set('checkInFrequency')}
            placeholder="e.g., Weekly, Bi-Weekly"
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default BondConditionsSection;
